import store from '@/store';
import { ENGRAVING, ANNEALING } from '@/constants';
import { getMaterialWithLaserParameters } from './';

export default () => {
  const { core: { laserOutputQuality } } = store.getState();
  const materialWithLaserParameters = getMaterialWithLaserParameters();
  if (materialWithLaserParameters.available) {
    switch (laserOutputQuality) {
      case ENGRAVING: {
        return 'E';
      }
      case ANNEALING: {
        return 'A';
      }
      default: {
        break;
      }
    }
  }
  return 'N';
};
